import { Component } from '@angular/core';

@Component({
	selector: 'op-esign-show-error',
	templateUrl: './esign-show-error.component.html',
	styles: ['']
})
export class EsignShowErrorComponent {}
